<template>
  <div>
    <v-dialog
      v-model="isShowDialog"
      persistent
      :width="matchPanelSize"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between ">
          <span>NEW USER <br v-if="$vuetify.breakpoint.name == 'xs'"> ({{ getSelectedDevice?.name }}, ID:{{ getSelectedDevice?.id }})</span>
          <div>
            <v-btn 
              :disabled="loading"
              outlined
              @click="grantAccessHide"
              class="text-right text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
              :x-large="$vuetify.breakpoint.name == 'xl'"
              :large="$vuetify.breakpoint.name == 'lg'"
            >
              <v-icon color="white">
                mdi-close
              </v-icon>
            </v-btn>
          </div>
          <!--<v-col class="col-12 d-flex justify-center">
            <h2 class="mt-2" v-if="device">for object {{ device.name }}, {{ getDeviceTypes.filter(tp => tp.id == device.device.deviceTypeId)[0].name }}+{{ getSubDeviceTypes.filter(tp => tp.id == device.subDevice.typeId)[0].name }}, ID: DVC{{`000${device.id}`.substring(`000${device.id}`.length-3, `000${device.id}`.length)}}</h2>
          </v-col>-->
        </v-card-title>
        <v-card-text>
          <v-row class="mt-3">
            <v-col class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <v-row no-gutters class="d-flex justify-space-around">
                <v-col class="col-12">
                  <v-row>
                    <v-col class="col-6 col-xl-4 col-lg-4 col-md-4 col-sm-4">
                      <v-text-field
                        :disabled="loading"
                        label="First name"
                        outlined
                        v-model="createUserDto.FirstName"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-6 col-xl-4 col-lg-4 col-md-4 col-sm-4">
                      <v-text-field
                        :disabled="loading"
                        label="Last name"
                        outlined
                        v-model="createUserDto.LastName"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-4">
                      <v-text-field
                        :disabled="loading"
                        label="Phone number"
                        outlined
                        v-model="createUserDto.PhoneNumber"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <h3 class="mt-3">User Document ID</h3>
                  <v-row>
                    <v-col class="col-12 col-xl-4 col-lg-4 col-md-4 col-sm-4">
                      <v-text-field
                        class="mt-3"
                        :disabled="loading"
                        label="Document number"
                        outlined
                        v-model="createUserDto.DocumentData"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <h3 class="mt-3 mb-3">Permission</h3>
                  <v-row>
                    <v-col class="col-6">
                      <v-text-field
                        :disabled="loading"
                        label="Login / E-mail"
                        outlined
                        type="email"
                        v-model="createUserDto.Email"
                        :error-messages="emailErrors"
                        required
                        @input="$v.createUserDto.Email.$touch()"
                        @blur="$v.createUserDto.Email.$touch()"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-6">
                      <v-select
                        :disabled="loading"
                        outlined
                        v-model="userAccessPages"
                        :items="accessPages"
                        item-text="name"
                        item-value="type"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Access Pages"
                        multiple
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col class="col-6">
                      <v-text-field
                        :disabled="loading"
                        label="Password"
                        outlined
                        type="password"
                        v-model="createUserDto.Password"
                        :error-messages="passwordErrors"
                        required
                        @input="$v.createUserDto.Password.$touch()"
                        @blur="$v.createUserDto.Password.$touch()"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-6">
                      <v-text-field
                        :disabled="loading"
                        label="Confirm password"
                        outlined
                        type="password"
                        v-model="createUserDto.PasswordAccept"
                        :error-messages="passwordAcceptErrors"
                        required
                        @input="$v.createUserDto.PasswordAccept.$touch()"
                        @blur="$v.createUserDto.PasswordAccept.$touch()"
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-4">
                <v-col class="col-6 d-flex justify-start">
                </v-col>
                <v-col class="col-6 d-flex justify-end">
                  <v-btn :disabled="loading" depressed outlined 
                    class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                    :x-large="$vuetify.breakpoint.name == 'xl'"
                    :large="$vuetify.breakpoint.name == 'lg'"
                    @click="saveGrantAccess">
                    SAVE
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import md5 from 'md5'
  import { validationMixin } from 'vuelidate'
  import { required, minLength, email } from 'vuelidate/lib/validators'
  import validationService from '@/services/validationService'
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  export default {
    mixins: [validationMixin],
    props: ['isShowDialog'],
    name: 'GrantAccess',
    validations: {
      createUserDto:{
        PasswordAccept:  { required, minLength: minLength(6) },
        Password: { required, minLength: minLength(6) },
        Email: { required, email }
      }
    },
    data(){
      return {
        device: null,
        userAccessPages: [],
        accessPages: [
          {
            name: 'Find Object',
            type: 'FilterObjects'
          },
          {
            name: 'Reports',
            type: 'Reports'
          },
          {
            name: 'Events',
            type: 'Events'
          },
          {
            name: 'Graphic',
            type: 'Graphic'
          },
          {
            name: 'Account Access',
            type: 'AccountAccess'
          },
          {
            name: 'Supplies',
            type: 'Supplies'
          },
          {
            name: 'Tariffs',
            type: 'Tariffs'
          }
        ],
        createUserDto: {
          AgregatorId: 0,
          FirstName: '',
          LastName: '',
          PhoneNumber: '',
          DocumentData: '',
          Email: '',
          Password: '',
          PasswordAccept: '',
          DeviceId: 0,
          Permissions: {
            FilterObjects: false,
            Reports: false,
            Events: false,
            Graphic: false,
            AccountAccess: false,
            Supplies: false,
            Tariffs: false
          }
        },
        loading: false
      }
    },
    computed:{
      ...mapGetters(['getDeviceTypes', 'getSubDeviceTypes', 'getSubjectCreationDatas', 'getSelectedDevice']),
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      },
      passwordErrors () {
        return validationService.passwordErrors(this.$v.createUserDto.Password)
      },
      passwordAcceptErrors () {
        return validationService.passwordErrors(this.$v.createUserDto.PasswordAccept)
      },
      emailErrors () {
        return validationService.emailErrors(this.$v.createUserDto.Email)
      },
    },
    created(){
      this.$root.$on('GrantAccess', async (dv) => {
        this.device = dv
      })
    },
    methods:{
      ...mapActions(['createUserByAgregator']),
      grantAccessHide(){
        this.$emit("HideGrantAccess")
      },
      async saveGrantAccess(){
        this.loading = true
        this.$root.$emit('loading', "start")
        Object.entries(this.createUserDto).forEach(data => {
          if(data[1].length < 2 && data[0] != 'AgregatorId'){
            this.$noty.error(`Check field ${data[0]}`)
            this.loading = false
            this.$root.$emit('loading', "end")
          }
        })
        if(this.createUserDto.Password && this.createUserDto.PasswordAccept== this.createUserDto.Password && this.createUserDto.Password!=null && this.createUserDto.Password!=''){
          this.createUserDto.Password = md5(this.createUserDto.Password)
        }else{
          this.$noty.error(`Check field Password/Confirm password`)
          this.loading = false
        }
        if(!this.loading){
          return
        }
        this.createUserDto.DeviceId = this.device.id
        Object.entries(this.createUserDto.Permissions).forEach(permission => {
          if(this.userAccessPages.filter(p => p == permission[0]).length > 0){
            this.createUserDto.Permissions[permission[0]] = true
          }
        })
        
        await this.createUserByAgregator(this.createUserDto)
        .then(result => {
          this.$noty.success("User has bean created!")
          this.loading = false
            this.$root.$emit('loading', "end")
        })
        .catch(e => {
          console.log(e)
          this.$root.$emit('globalError', e.code)
          this.$root.$emit('loading', "end")
          this.loading = false
        })
        console.log(this.createUserDto)
      }
    }
  }
</script>
